import { localContentPrefix } from '../../../config';
import { AggregationResponseOut } from '../../../store/api';
import { http } from '../../../api/axios';
import { FetchAggregationsOptions } from '../../../api/listContent/fetchAggregations';
import { AgeCategory } from '../../../../models/AgeCategory';

type Options = FetchAggregationsOptions & {
    readonly ageCategory?: string;
    readonly shopLanguage: string | undefined;
};

export const fetchAllTitlesAggregations = (options: Options): Promise<AggregationResponseOut> => {
    return http
        .post<AggregationResponseOut>(`${localContentPrefix}/v1/marketplace/list/aggregation`, options.filters, {
            signal: options.signal,
            params: {
                ageCategory: options.ageCategory === AgeCategory.ALL_AGES ? undefined : options.ageCategory,
                shopLanguage: options.shopLanguage
            }
        })
        .then(response => response.data);
};
